import React from 'react'
import Head from 'next/head'
import { useTranslation } from 'i11n/client'

interface Props {
  title: string
}

function Header(props: Props) {
  const translate = useTranslation()
  const title = `Autoinspector | ${translate(props.title)}`

  return (
    <Head>
      <title>{title}</title>
    </Head>
  )
}

export default Header
